import React from 'react';
import DropdownList from '../../FormElements/DropdownList';
import AdvancedDataTable from '../../DataTables/AdvancedDataTable';
import MobileDataTableCard from '../../DataTables/MobileDataTableCard';
import Cell from '../../DataTables/DataTableComponents/Cell';
import Tooltip from '../../Tooltip/Tooltip';

export default function PropertyTaxReturnsCard(props) {
	return (
		<div className="PropertyTaxReturnsCard bg-white w-full min-w-96 mt-4 p-5 rounded-md shadow border text-gray-800">
			<div className="grid grid-cols-12 lg:gap-6">
				<div className="col-span-12 lg:col-span-2">
					<h2 className="text-lg lg:text-xl font-semibold mb-2">Tax Returns</h2>
					<div className="inline-block mr-2">
						<DropdownList
							label="Year"
							displayLabel={false}
							// onChange={this.onChange}
							id="year"
							name="year"
							// value={this.state.year }
							data={[
								{
									id: 1,
									name: '2023'
								}
							]}
						/>
					</div>
					<div className="inline-block">
						<DropdownList
							label="Month"
							displayLabel={false}
							// onChange={this.onChange}
							id="month"
							name="month"
							// value={this.state.month}
							data={[
								{
									id: 1,
									name: 'Jan'
								},
								{
									id: 2,
									name: 'Feb'
								},
								{
									id: 3,
									name: 'Mar'
								},
								{
									id: 4,
									name: 'Apr'
								},
								{
									id: 5,
									name: 'May'
								},
								{
									id: 6,
									name: 'Jun'
								},
								{
									id: 7,
									name: 'Jul'
								},
								{
									id: 8,
									name: 'Aug'
								},
								{
									id: 9,
									name: 'Sep'
								},
								{
									id: 10,
									name: 'Oct'
								},
								{
									id: 11,
									name: 'Nov'
								},
								{
									id: 12,
									name: 'Dec'
								}
							]}
						/>
					</div>
				</div>
				<div className="col-span-12 lg:col-span-10">
					<div className="contents lg:hidden">
						<MobileDataTableCard
							margin="my-0"
							data={[
								{
									form: 'G-45',
									form_name: 'General Excise/Use Tax Return',
									accounting_period: '1/1/20223 - 1/31/2023',
									nights_rented: 15,
									gross_revenue: 1254.24,
									exempt_revenue: 1254.24,
									taxable_revenue: 1000.0,
									tax_rate: 4.715,
									taxes_due: 47.15
								},
								{
									form: 'TA-1',
									form_name: 'Periodic Transient Accommodations Tax Return',
									accounting_period: '1/1/20223 - 1/31/2023',
									nights_rented: 15,
									gross_revenue: 1254.24,
									exempt_revenue: 1254.24,
									taxable_revenue: 1000.0,
									tax_rate: 10,
									taxes_due: 100.0
								}
							]}
							// endpoint={props.get_properties_endpoint}
							rowRenderer={(row) => {
								// console.log('PropertyInvoicesCard - invoice row', row);
								let labels = [
									{
										displayName: 'Form',
										apiName: 'form',
										alignment: 'left'
									},
									{
										displayName: 'Name',
										apiName: 'form_name',
										alignment: 'left'
									},
									{
										displayName: 'Accounting Period',
										apiName: 'accounting_period',
										alignment: 'left'
									},
									{
										displayName: 'Nights Rented',
										apiName: 'nights_rented',
										alignment: 'left'
									},
									{
										displayName: 'Gross Revenue',
										apiName: 'gross_revenue',
										alignment: 'left'
									},
									{
										displayName: 'Exempt Revenue',
										apiName: 'exempt_revenue',
										alignment: 'left'
									},
									{
										displayName: 'Taxable Revenue',
										apiName: 'taxable_revenue',
										alignment: 'left'
									},
									{
										displayName: 'Tax Rate',
										apiName: 'tax_rate',
										alignment: 'left'
									},
									{
										displayName: 'Taxes Due',
										apiName: 'taxes_due',
										alignment: 'left'
									}
								];
								return (
									<div
										key={row.form}
										className="p-4 bg-gray-50 border-t text-gray-800"
									>
										<div className="font-semibold">{labels[0].displayName}</div>
										<div>
											<Cell
												value={`${row.form} - ${row.form_name}`}
												type="text"
											/>
										</div>
										<div className="mt-4 font-semibold">
											{labels[2].displayName}
										</div>
										<div>
											<Cell value={row.accounting_period} type="text" />
										</div>
										<div className="mt-4 font-semibold">
											{labels[3].displayName}
										</div>
										<div>
											<Cell value={row.nights_rented} type="text" />
										</div>
										<div className="mt-4 font-semibold">
											{labels[4].displayName}
										</div>
										<div>
											<Cell
												value={<span>${row.gross_revenue}</span>}
												type="text"
											/>
										</div>
										<div className="mt-4 font-semibold">
											{labels[5].displayName}
										</div>
										<div>
											<Cell
												value={<span>${row.exempt_revenue}</span>}
												type="text"
											/>
										</div>
										<div className="mt-4 font-semibold">
											{labels[6].displayName}
										</div>
										<div>
											<Cell
												value={<span>${row.taxable_revenue}</span>}
												type="text"
											/>
										</div>
										<div className="mt-4 font-semibold">
											{labels[7].displayName}
										</div>
										<div>
											<Cell value={<span>{row.tax_rate}%</span>} type="text" />
										</div>
										<div className="mt-4 font-semibold">
											{labels[8].displayName}
										</div>
										<div>
											<Cell value={<span>${row.taxes_due}</span>} type="text" />
										</div>
									</div>
								);
							}}
						/>
					</div>
					<div className="hidden lg:contents">
						<AdvancedDataTable
							margin="my-0"
							shadow="shadow-sm"
							data={[
								{
									form: 'G-45',
									form_name: 'General Excise/Use Tax Return',
									accounting_period: '1/1/20223 - 1/31/2023',
									nights_rented: 15,
									gross_revenue: 1254.24,
									exempt_revenue: 1254.24,
									taxable_revenue: 1000.0,
									tax_rate: 4.715,
									taxes_due: 47.15
								},
								{
									form: 'TA-1',
									form_name: 'Periodic Transient Accommodations Tax Return',
									accounting_period: '1/1/20223 - 1/31/2023',
									nights_rented: 15,
									gross_revenue: 1254.24,
									exempt_revenue: 1254.24,
									taxable_revenue: 1000.0,
									tax_rate: 10,
									taxes_due: 100.0
								}
							]}
							// endpoint={props.get_properties_endpoint}
							style="text-gray-800 border-b-2 border-gray-300 font-semibold"
							columns={[
								{
									displayName: 'Form',
									apiName: 'form',
									alignment: 'left'
								},
								{
									displayName: 'Accounting Period',
									apiName: 'accounting_period',
									alignment: 'left'
								},
								{
									displayName: 'Nights Rented',
									apiName: 'nights_rented',
									alignment: 'right'
								},
								{
									displayName: 'Gross Revenue',
									apiName: 'gross_revenue',
									alignment: 'right'
								},
								{
									displayName: 'Exempt Revenue',
									apiName: 'exempt_revenue',
									alignment: 'right'
								},
								{
									displayName: 'Taxable Revenue',
									apiName: 'taxable_revenue',
									alignment: 'right'
								},
								{
									displayName: 'Tax Rate',
									apiName: 'tax_rate',
									alignment: 'right'
								},
								{
									displayName: 'Taxes Due',
									apiName: 'taxes_due',
									alignment: 'right'
								}
							]}
							rowRenderer={(row) => {
								// console.log('PropertiesCard - property row', row);
								return (
									<tr
										key={row.form}
										className="bg-white border-t text-gray-800"
									>
										<td className="pl-8 py-3 text-left">
											<Cell
												value={
													<div className="block w-20">
														{row.form}{" "}
														<Tooltip text={row.form_name}>
															<i className="fa fa-info-circle text-gray-700" />
														</Tooltip>
													</div>
												}
												type="text"
											/>
										</td>
										<td className="pl-8 pr-6 py-3 text-left">
											<Cell value={row.accounting_period} type="text" />
										</td>
										<td className="pl-8 pr-8 py-3 text-right">
											<Cell value={row.nights_rented} type="text" />
										</td>
										<td className="pl-8 pr-8 py-3 text-right w-80">
											<Cell
												value={<span>${row.gross_revenue}</span>}
												type="text"
											/>
										</td>
										<td className="pl-8 pr-8 py-3 text-right w-80">
											<Cell
												value={<span>${row.exempt_revenue}</span>}
												type="text"
											/>
										</td>
										<td className="pl-8 pr-8 py-3 text-right w-80">
											<Cell
												value={<span>${row.taxable_revenue}</span>}
												type="text"
											/>
										</td>
										<td className="pl-8 pr-8 py-3 text-right w-80">
											<Cell value={<span>{row.tax_rate}%</span>} type="text" />
										</td>
										<td className="pl-8 pr-8 py-3 text-right w-80">
											<Cell value={<span>${row.taxes_due}</span>} type="text" />
										</td>
									</tr>
								);
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
